import { render, staticRenderFns } from "./FormCategoryForm.vue?vue&type=template&id=60a101ac"
import script from "./FormCategoryForm.vue?vue&type=script&lang=js"
export * from "./FormCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a101ac')) {
      api.createRecord('60a101ac', component.options)
    } else {
      api.reload('60a101ac', component.options)
    }
    module.hot.accept("./FormCategoryForm.vue?vue&type=template&id=60a101ac", function () {
      api.rerender('60a101ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/FormCategoryForm.vue"
export default component.exports